<script>
import BasePopup from '../../BasePopup.vue';
import BaseSelect from '../../BaseSelect.vue';

export default {
  name: 'TaskViewParametersPopup',
  components: { BasePopup, BaseSelect },
  props: {
    options: [Array, Object],
    header: String,
    label: String,
  },
  data() {
    return {
      value: null,
    };
  },
};
</script>

<template lang="pug">
BasePopup(@close="$emit('close')" :zIndex="9000")
  .statuses
    .status-header {{ header }}
    .options
      BaseSelect(v-model="value" :label="label" :options="options")
    .buttons
      Btn(@click="$emit('submit', value)" transparent round narrow :disabled="!value") Применить
      Btn(@click="$emit('close')" transparent round narrow) Отменить
</template>

<style scoped lang="scss">
.status-header {
  display: flex;
  justify-content: center;
  color: rgba(35, 34, 38, 1);
  font-family: Geometria, sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}

.options {
  padding-top: 41px;
  padding-bottom: 35px;
  display: grid;
  grid-template-columns: 1fr;
  justify-content: center;
  width: 100%;
}

.buttons {
  display: flex;
  justify-content: space-between;
  gap: 30px;
}
</style>
